import React from 'react';
import PropTypes from 'prop-types';

class VideoPlayer extends React.Component {
  componentDidMount() {
    this.createPlayer(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.player) {
      if (nextProps.sources[0].src !== this.props.sources[0].src) {
        this.player.src(nextProps.sources[0]);
      }
    }
  }

  createPlayer(props) {
    this.player = window.videojs(this.videoNode, props, () => {
      //this.player.playbackRate(2.0);
    });
    this.player.on('timeupdate', function() {
      if (props.onTimeUpdate) props.onTimeUpdate(this.currentTime());
    });

    this.player.on('loadedmetadata', () => {
      if (props.onMetadata)
        props.onMetadata({ duration: this.player.duration() });
    });

    this.player.on('play', () => {
      if (props.onPlay) props.onPlay();
    });

    this.player.on('pause', () => {
      if (props.onPause) props.onPause();
    });
  }

  isPlaying() {
    if (this.player) return !this.player.paused();
    return false;
  }

  isFullscreen() {
    if (this.player) return this.player.isFullscreen();
    return false;
  }

  pause() {
    if (this.player) this.player.pause();
  }

  exitFullscreen() {
    if (this.player) this.player.exitFullscreen();
  }

  componentWillUnmount() {
    if (this.player) this.player.dispose();
  }

  render() {
    return (
      <div data-vjs-player>
        <video
          ref={node => (this.videoNode = node)}
          className="video-js vjs-fluid"
          style={{ maxWidth: '100%' }}
          controls
        />
      </div>
    );
  }
}

VideoPlayer.propTypes = {
  sources: PropTypes.array.isRequired,
  onMetadata: PropTypes.func,
  onPause: PropTypes.func,
  onPlay: PropTypes.func,
  onTimeUpdate: PropTypes.func
};

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoPlayer.js